import { CollectionNoticeModel } from '../collection-notice.model';
import { ApiModel } from '../generic-state.model';
import { InvoicingPayloadDataModel } from '../invoicing-data.model';
import { PaymentMethodModel } from '../payment-method.model';

export interface ExternalCollectionNoticeModel extends CollectionNoticeModel {
  amount: string;
  deadlineAt: string;
  email: string;
  emittedAt: string;
  provider: ExternalColleactionNoticeProviderModel;
  reference: string;
  status: string;
  subConcept: SubconceptModel;
  type: 'interno' | 'externo';
}

export interface ExternalColleactionNoticeProviderModel {
  email: string;
  id: string;
  lastName: string;
  name: string;
  secondLastName: string;
}

export interface ExternalInvoiceModel extends ApiModel {
  collectionNotice: ExternalCollectionNoticeModel;
  emittedAt: string;
  receptor: string;
  rfcEmitter: string;
  rfcReceptor: string;
  status: string;
  totalAmount: number;
}

export interface ExternalPaymentModel extends ApiModel {
  billpocketPaymentsRefund: number;
  collectionNoticeId: string;
  description: string;
  email: string;
  invoiceId?: string;
  isBilled: string;
  isGeneralPublic: boolean;
  msi: boolean;
  paymentDate: string;
  paymentType: string;
  reference: string;
  status: string;
  studentName: string;
  subConceptName: string;
  syncfyDispersionAt?: string;
  totalPaid: number;
  paymentId: string;
}

export interface ExternalPaymentParamsModel {
  collectionNoticeId?: string;
  email?: string;
  token?: string;
}

export interface ExternalPaymentsModel {
  collectionNotice?: CollectionNoticeModel;
  cvv?: {
    tokenized: boolean;
    value: string;
  };
  featureFlags: { [flag: string]: boolean | undefined };
  idempotencyKey?: string;
  invoicingData?: InvoicingPayloadDataModel;
  isLoading: boolean;
  params?: ExternalPaymentParamsModel;
  paymentMethod?: PaymentMethodModel;
}

export enum ExternalPaymentStep {
  DETAIL = 0,
  BILLING = 1,
  PAYMENT = 2,
  STATUS = 3,
}

export interface SubconceptModel {
  id: string;
  name: string;
  isBillable: number;
}
